import LibraryApiCall from 'LibraryApiCall';
import config from "config";
import { useEffect } from 'react';


// GET LIBRARY ACCESS DETAILS ACTION CREATOR  
export const getLibraryAccessDetails = () => {
    return async dispatch => {
        // METHOD TO DISPATCH SET ADMIN FETCHING ACTION CREATOR
        dispatch(setAdminFetching(true));

        let requestData = {
            'institute_id': config.institute_id,
            'facultyId': config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryUserAccess',
            requestData,
            '/api/library/libraryGrantAccess.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                dispatch(getLibraryAccessDetails());
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let accessibleScreens = [];
                let accessibleOperations = [];
                let isAdmin = jsonResponse.APIResult.isAdmin == 'true' ? true : false;
                let isScreenAccessAvailable = jsonResponse.APIResult.isScreenAccessAvailable == 'true' ? true : false;
                let isStoreIncharge = jsonResponse.APIResult.isStoreIncharge == 'true' ? true : false;

                if (Object.keys(apiResult).length > 0) {
                    Object.values(apiResult).map(accessDetails => {
                        if (Object.keys(accessDetails.access).length > 0) {
                            accessibleScreens = Object.keys(accessDetails.access);
                            accessibleOperations = accessDetails.access;
                        }
                    });
                }

                // METHOD TO DISPATCH SET ADMIN FETCHING ACTION CREATOR
                dispatch(setAdminFetching(false));

                // METHOD TO DISPATCH SET LIBRARY ADMIN DETAILS ACTION CREATOR
                dispatch(setLibraryAdminDetails(isScreenAccessAvailable,accessibleOperations, accessibleScreens, isAdmin, isStoreIncharge));
            }
        }
    }
};


// SET ADMIN FETCHING ACTION CREATOR
export const setAdminFetching = (adminFetching) => {
    return {
        type: 'SET_ADMIN_FETCHING',
        adminFetching
    };
}

// // SET COLLABORATING AGENCY DETAILS ACTION CREATOR
// export const getAdminDetails = apiResult => {
//     return {
//         type: 'SET_FEEDBACK_ADMIN_DETAILS',
//         apiResult
//     };
// };

// SET LIBRARY ADMIN DETAILS ACTION CREATOR
export const setLibraryAdminDetails = (accessDetails,accessibleOperations, accessibleScreens, isAdmin, isStoreIncharge) => {
    
    return {
        type: 'SET_LIBRARY_ADMIN_DETAILS',
        payload: {
            accessDetails,
            accessibleScreens,
            accessibleOperations,
            isAdmin,
            isStoreIncharge
        }
    };
};

// SET ADMIN FETCHING ACTION CREATOR
export const setAssignedIIdArray = (assignedIIDArray) => {
    return {
        type: 'ASSIGNED_IID_ARRAY',
        assignedIIDArray
    };
};

// SET ADMIN FETCHING ACTION CREATOR
export const setAssignedInstitute = (assignedInstitute) => {
    
    return {
        type: 'ASSIGNED_INSTITUTE',
        assignedInstitute
    };
};

//GET ASSIGNED INSTITUTE ARRAY
export const getAssignedIIDArray = apiResult => {
    return {
        type: 'GET_ASSIGNED_INSTITUTE_ARRAY',
        apiResult
    };
};

//GET ASSIGNED INSTITUTE OBJECT
export const getAssignedInstituteObject = apiResult => {
    return {
        type: 'GET_ASSIGNED_INSTITUTE_OBJECT',
        apiResult
    };
};
